// @ts-nocheck
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

export const MobilePageContainer = ({ children, className }: Props) => {
  return <div className={cn('pb-4', className)}>{children}</div>;
};
